// @flow
import * as React from 'react';
import type { PopperArrowProps } from 'react-popper';
import type { Placement } from 'popper.js';

export type PopperChildrenProps = {
    arrowProps?: PopperArrowProps,
    outOfBoundaries?: ?boolean,
    placement?: Placement,
    scheduleUpdate?: () => void,
    // $FlowFixMe https://github.com/facebook/flow/issues/5192
    style?: React.CSSProperties,
};
